class DeliveryCountryMessage extends HTMLElement {
	static countryNamePromise;

	attributes = {
		messageTemplate: 'data-message-template'
	};

	connectedCallback() {
		this.messageTemplate = this.getAttribute(this.attributes.messageTemplate);

		this.init();
	}

	init() {
		if (
			!this.messageTemplate ||
			!window.Shopify?.loadFeatures ||
			!Intl.DisplayNames
		)
			return;

		if (!DeliveryCountryMessage.countryNamePromise) {
			DeliveryCountryMessage.countryNamePromise = new Promise(resolve => {
				window.Shopify.loadFeatures(
					[{ name: 'consent-tracking-api', version: '0.1' }],
					error => {
						if (error) {
							resolve(null);
							return;
						}

						const countryCode = window.Shopify.customerPrivacy?.getRegion()?.slice(0, 2);
						const countryName = countryCode
							? new Intl.DisplayNames(['en'], { type: 'region' }).of(countryCode)
							: null;
						resolve(countryName);
					}
				);
			});
		}

		DeliveryCountryMessage.countryNamePromise.then(countryName => {
			if (!this.isConnected || !countryName) return;

			this.textContent = this.messageTemplate.replaceAll('[[country]]', countryName);
		});
	}
}

if (!customElements.get('delivery-country-message')) {
	customElements.define('delivery-country-message', DeliveryCountryMessage);
}
